// import { HttpAdapter } from "../../../config/http/http.adapter";
import { HttpAdapter } from '../../../config/http/http.adapter';
import { MainBoardResponse } from '../../../infraestructure/interfaces/main-board.interface';
import { GeneralDataMapper } from '../../../infraestructure/mappers/general-data.mapper';
import { GeneralGroupData } from '../../entities/general/GeneralGroupData.entity';
import { handleError } from '../../handle-error/handleError';
import moment from 'moment';

// Fecha actual en el formato deseado
const currentDate = moment().format('YYYY-MM-DD');

// Fecha restando 12 meses
const originDate = moment().subtract(12, 'months').format('YYYY-MM-DD');

interface Props {
  clientId: string;
  dateFrom: string | Date;
  dateTo: string | Date;
}

export const GetDataGeneralUseCases = async (
  fetcher: HttpAdapter,
  props: Props
): //   fetcher: HttpAdapter
Promise<GeneralGroupData> => {
  try {
    const { clientId, dateFrom = originDate, dateTo = currentDate } = props;

    const response = await fetcher.post<MainBoardResponse>(
      '/data-ms/main-board',
      {
        clientId: `${clientId}`,
        dateFrom: `${dateFrom}`,
        dateTo: `${dateTo}`,
      }
    );

    return GeneralDataMapper.fromResponseToEntity(response);
  } catch (error: any) {
    console.log(error);
    const processedError = handleError(error);
    console.error('Error procesado:', processedError);
    throw new Error(`${processedError.message} ${processedError.status}`);
  }
};
